export const MealPlanAside = {
  bindings: {
    active: '<',
    subscriptionId: '<',
    totalByVoome: '<',
    totalMine: '<',
    onClick: '&',
  },

  template: `
    <div>
      <div class="mb-3 pl-2 pt-2 pb-2 pointer icon rounded"
        ng-class="{ 'bg-white border': $ctrl.active === 'byVoome' }"
        ng-click="$ctrl.onClick({ type: 'byVoome' })">
        <h6 class="mb-1">Ready-made Plans</h6>
        <small class="text-dark">
          Start with one of our {{ $ctrl.totalByVoome }} plans,
          and build from there.
        </small>
      </div>
      <div class="mb-3 pl-2 pt-2 pb-2 pointer icon rounded"
        ng-class="{ 'bg-white border border': $ctrl.active === 'mine' }"
        ng-click="$ctrl.onClick({ type: 'mine' })">
        <h6 class="mb-1">My Plans</h6>
        <small class="text-dark">
          <span ng-if="!$ctrl.totalMine">
            No plans have been created.
          </span>
          <span ng-if="$ctrl.totalMine == 1">
            View the plan you've created.
          </span>
          <span ng-if="$ctrl.totalMine > 1">
            View the {{ $ctrl.totalMine }} plans you've created.
          </span>
        </small>
      </div>
      <div class="mb-3 text-center">
        <meal-plan-create-button
          style="button"
          subscription-id="$ctrl.subscriptionId"
          count="$ctrl.totalMine">
          New Plan
        </meal-plan-create-button>
      </div>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/MealPlan/MealPlanAside.js